import SoqlDataProvider from '../visualizations/dataProviders/SoqlDataProvider';
import { ClientContextVariable } from 'common/types/clientContextVariable';

export interface SampleDataOptions {
  datasetUid: string;
  limitRows?: number;
  domain?: string;
  clientContextVariables?: ClientContextVariable[];
}

/**
 * Fetches sample data from a dataset using a SOQL query
 * Returns the top N rows from the dataset, limited to 10 by default
 *
 * @param options - Configuration options
 * @returns Promise that resolves to an array of data rows
 */
export async function getSampleData({
  datasetUid,
  limitRows = 10,
  domain,
  clientContextVariables = []
}: SampleDataOptions): Promise<any[]> {
  if (!datasetUid) {
    return Promise.resolve([]);
  }

  const soqlDataProvider = new SoqlDataProvider({
    datasetUid,
    domain,
    clientContextVariables
  });

  try {
    const queryFn = () => `SELECT * LIMIT ${limitRows}`;
    const result = await soqlDataProvider.invokeSoqlQuery(queryFn, []);

    return Array.isArray(result) ? result : [];
  } catch (error) {
    console.error('Error fetching sample data:', error);
    return [];
  }
}
